import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import HeaderMegaMenuMenuArticle from './HeaderMegaMenuMenuArticle';
import HeaderMegaMenuMenuButton from './HeaderMegaMenuMenuButton';
import HeaderMegaMenuMenuHeading from './HeaderMegaMenuMenuHeading';
import HeaderMegaMenuMenuItem from './HeaderMegaMenuMenuItem';
import HeaderMegaMenuMenuTagline from './HeaderMegaMenuMenuTagline';
import HeaderMegaMenuBack from './HeaderMegaMenuBack';
import HeaderContext from './HeaderContext';

const HeaderMegaMenuMenu = ({ children, id, title, isOpen, onClose }) => {
  const { closeMegaMenu } = useContext(HeaderContext);
  const className = `c-header-mega-menu__inner  c-header-mega-menu__submenu  ${isOpen ? 'is-open' : ''}`;

  const onKeyDown = ({ key }) => {
    if (key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className={className} onKeyDown={onKeyDown}>
      <HeaderMegaMenuBack title={title} onClick={() => closeMegaMenu(id)} />
      {isOpen && children}
    </div>
  );
};

HeaderMegaMenuMenu.Article = HeaderMegaMenuMenuArticle;
HeaderMegaMenuMenu.Button = HeaderMegaMenuMenuButton;
HeaderMegaMenuMenu.Heading = HeaderMegaMenuMenuHeading;
HeaderMegaMenuMenu.Item = HeaderMegaMenuMenuItem;
HeaderMegaMenuMenu.Tagline = HeaderMegaMenuMenuTagline;

export default HeaderMegaMenuMenu;

HeaderMegaMenuMenu.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
